import { render, staticRenderFns } from "./szMicros.vue?vue&type=template&id=1c5a6d9a&scoped=true"
import script from "./szMicros.vue?vue&type=script&lang=js"
export * from "./szMicros.vue?vue&type=script&lang=js"
import style0 from "./szMicros.vue?vue&type=style&index=0&id=1c5a6d9a&prod&lang=scss&scoped=true"
import style1 from "./szMicros.vue?vue&type=style&index=1&id=1c5a6d9a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c5a6d9a",
  null
  
)

export default component.exports